import React, { createElement } from 'react';

import AuthorSimple from './AuthorSimple';
import AuthorExtended from './AuthorExtended';

const authorVariants = {
  simple: AuthorSimple,
  extended: AuthorExtended,
};

export interface AuthorProps {
  name: string;
  role: string;
  region: string;
  image: React.ReactNode;
  description: React.ReactNode;
  variant: string;
}

const Author = ({ variant = 'simple', ...props }: AuthorProps) =>
  createElement(authorVariants[variant], { ...props, variant });

export default Author;
